import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
// import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.DO_ADD = function (state, payload) {
  let obj = {
    id: null,
    name: null,
    name_chi: null
  }
  state.rows.unshift(obj)
}
mutations.DO_EDIT = function (state, payload) {
  state.row = payload
}

const state = {
  rows: [],
  row: null,
  condition: {}
}

const actions = {
  init: ({ commit, state }, condition) => {
    const ctx = {
      data: {
        init: { api: 'P0102ProductCategoryService.getCategory' }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('FIND_ALL', data.init.output)
      })
  },
  doAdd: ({ commit, state }) => {
    console.debug('called C0003Category add')
    commit('DO_ADD')
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'P0101ProductService.doEdit', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('DO_EDIT', data.find.output)
      })
  },
  save: ({ commit, state }, condition) => {
    return client.postData({ data: { doSave: { api: 'P0102ProductCategoryService.doSave', input: condition } }
    })
      .then((data) => {
        commit('FIND_ALL', data.doSave.output)
      })
  },
  delete: ({ commit, state }, condition) => {
    return client.postData({ data: { doDelete: { api: 'P0102ProductCategoryService.doDelete', input: condition } }
    })
      .then((data) => {
        commit('FIND_ALL', data.doDelete.output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
